<mat-toolbar class="toolbar">
  <div class="toolbar-left">
    @if (userIsLoggedIn$ | async) {
      <button mat-icon-button (click)="openSideMenu()">
        <mat-icon>menu</mat-icon>
      </button>
    }
    <img alt="ALOORA Logo" src="./assets/aloora-logo.svg" />
  </div>
  <div class="toolbar-center on-mobile-hidden">
    <span class="page-name">{{ title | async }}</span>
  </div>
  <div class="toolbar-right">
    @if (newOrderButtonVisible | async) {
      <button
        mat-button
        color="primary"
        class="new-order-button on-mobile-hidden"
        [routerLink]="['order']">
        <mat-icon>add_circle</mat-icon>
        <span>{{ 'toolbar.newOrder' | translate }}</span>
      </button>
    }
    @if (pageIsReloadable$ | async) {
      <button class="on-mobile-only" mat-icon-button (click)="reloadPage()">
        <mat-icon>refresh</mat-icon>
      </button>
    }
    <button mat-icon-button class="help-menu-button" [matMenuTriggerFor]="menu">
      <mat-icon>help</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <a
        mat-menu-item
        target="_blank"
        class="help-button-container"
        [href]="'common.FAQ_LINK' | translate">
        {{ 'common.FAQ' | translate }}
      </a>
      @if (userIsLoggedIn$ | async) {
        <a mat-menu-item [routerLink]="['academy']">
          {{ 'academy.menu' | translate }}
        </a>
      }
      @if (showTutorialButton$ | async) {
        <button mat-menu-item (click)="startTutorial()">
          {{ 'orderingTutorial.startTutorial' | translate }}
        </button>
      }
    </mat-menu>
  </div>
</mat-toolbar>
